module.exports = __webpack_public_path__ + "static/media/muna_kaki_walk.317cb76e.png";